export default __webpack_public_path__ + "static/media/AfterPhoto10.5b2ac028.jpg";